if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      }

      config.body = formData;

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            // No native cart-drawer/cart-notification element exists on this theme
            // (cart_type is "page" so Shopify's own cart UI is intentionally not
            // rendered - the Rebuy app owns the cart drawer instead). Previously
            // this branch hard-navigated to Shopify's native /cart page, which is
            // exactly the "Shopify cart still shows up" bug: it raced against
            // Rebuy's own drawer and sometimes won. Instead, just let the AJAX
            // add-to-cart complete silently and publish the same cartUpdate event
            // the normal path publishes below - Rebuy listens for that / the
            // cart/add.js response itself and opens its own drawer.
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
            this.error = false;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 * Fix: stop the color-swatch / variant picker from swapping the main product
 * gallery image on variant change. Shopper-requested behavior: the gallery
 * should stay on whatever image is currently showing (default: first image)
 * regardless of which color swatch is selected. Price, availability and the
 * cart submission (variant id) must keep working normally - only the
 * gallery/media-swap portion of the variant-change handler is disabled.
 *
 * The Dawn-based `variant-selects` / `variant-radios` custom elements
 * (defined in assets/global.js) call `this.updateMedia()` from their
 * `onVariantChange()` handler as a fully separate step from price/cart
 * updates. Neutralizing that one method on the shared prototype leaves
 * updateOptions/updateMasterId/updateVariantInput/renderProductInfo/etc.
 * untouched. This file loads (deferred) on every product page after
 * global.js, so VariantSelects/VariantRadios are already defined when this
 * runs.
 */
(function () {
  try {
    if (typeof VariantSelects !== 'undefined' && VariantSelects.prototype) {
      VariantSelects.prototype.updateMedia = function () {};
    }
    if (typeof VariantRadios !== 'undefined' && VariantRadios.prototype) {
      VariantRadios.prototype.updateMedia = function () {};
    }
  } catch (e) {
    console.error('[product-form.js] could not disable variant media-swap:', e);
  }
})();
